// views/dashboard/services/index.js
import { analyticsService } from "./analytics/analytics-service";

export const services = {
  analytics: analyticsService,
};

export default services;
